import { createBrowserMeasurement } from "@tabbio/utils/analytics/browser-context";
import { measurementCookieStorage } from "@tabbio/utils/analytics/browser-cookies";

export const browserMeasurementCookies = measurementCookieStorage({
  hostname: () => new URL(window.location.href).hostname,
  secure: () => new URL(window.location.href).protocol === "https:",
  read: () => document.cookie ?? "",
  write: (value) => {
    document.cookie = value;
  },
});

export const browserMeasurement = createBrowserMeasurement({
  storage: browserMeasurementCookies,
  location: () => window.location.href,
  referrer: () => document.referrer ?? "",
  scroll: () => ({
    top: window.scrollY ?? 0,
    height: document.documentElement?.scrollHeight ?? 0,
    viewport: window.innerHeight ?? 0,
  }),
});
